@if (showTitle == true) {
  <div>
    <app-page-header title="Rapporter" [translateTitle]="false" icon="description"></app-page-header>
  </div>
}
<div [ngClass]="isEmbedded ? '' : 'page-content'">

  @if (!isEmbedded) {
    <div class="flex-row flex-col-ltsm gap-col-1em">
      @if (!fixedView) {
        <mat-form-field class="flex-1">
          <mat-label>Välj vy</mat-label>
          <mat-select [(value)]="currentViewId" (selectionChange)="$event? viewChanged($event) : null">
            @for (currentView of availableViews | async; track currentView) {
              <mat-option [value]="currentView.viewId">
                {{ currentView.viewName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field class="flex-1">
        <mat-label>{{'globalTexts.SearchInstruction' | translate}}</mat-label>
        <input [(value)]="currentSearchText" matInput type="search" (keyup)="applyFilter($event.target.value)">
      </mat-form-field>
    </div>
  }

  <div [ngClass]="isEmbedded ? '' : 'mat-elevation-z8'">
    @if (loadingIndicator) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="reportId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.reportId}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Rapportnamn </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="reportStatusName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.reportStatusName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="businessCategoryName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Verksamhetskat. </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.businessCategoryName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="scoreLevelName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Bedömning </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.scoreLevelName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="businessName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Verksamhet </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.businessName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="visitDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Besöksdatum </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.visitDate | dateFormatter }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="approvalDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Godk.datum </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.approvalDate | dateFormatter }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="regionName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.regionName }} </mat-cell>
      </ng-container>

      @if (canManageReports) {
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex-50px justify-center">
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="flex-50px justify-center">
            <button mat-icon-button matTooltip="{{'commands.Edit' | translate}}" (click)="gotoReportDetails(row)">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
      }

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    @if (!isEmbedded) {
      <mat-paginator   hidePageSize="true" pageSize="15" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>
    }

    @if (canManageReports && methodVersionId == null) {
      <section class="button-container">
        @if (hasPermissionToChange()) {
          <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" (click)="gotoReportDetails()"><mat-icon>add</mat-icon></button>
        }
      </section>
    }

  </div>
</div>
